export default "__VITE_ASSET__ce68d0b6__"